import type { TFunction } from 'i18next';

/** Map Node `/api/ep/orders` status strings to localized labels. */
export function getEpStatusLabel(status: string, t: TFunction): string {
  const statusMap: Record<string, string> = {
    open: t('epTrading.statusOpen'),
    claimed: t('epTrading.statusClaimed', '待付款'),
    paid: t('epTrading.statusPaid', '已付款'),
    partial: t('epTrading.statusPartial'),
    done: t('epTrading.statusDone'),
    filled: t('epTrading.statusDone'),
    cancelled: t('epTrading.statusCancelled'),
    timeout: t('epTrading.statusCancelled'),
    dispute: t('epTrading.statusDispute'),
    disputed: t('epTrading.statusDispute'),
  };
  return statusMap[status] ?? status;
}
